import { createTracker } from 'usage-tracker';
import events from 'campaigns-lib/events.yaml';
export const UsageTracker = createTracker({
  events,
  properties: {
    namespace: 'campaigns-lib'
  }
});